export const ERROR_SUFFIX = '_ERROR'
export const INITIAL_STATE = {}
export const SUCCESS_SUFFIX = '_SUCCESS'
